import { ThunkType } from "../../../../../core/store/reducers";
import { getMonthlyTradingReport } from "../api/getMonthlyTradingReport";
import fileDownload from "js-file-download";
import { setFetchState } from "../monthlyTradeDataSlice";

export const downloadOrdersReport = (): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful") {
		return undefined;
	}

	const { filter } = store.ux.reports.securityCommission.monthlyTrade;
	const user = store.data.auth.current.user;
	dispatch(setFetchState({ type: "started" }));
	const ordersReport = await dispatch(getMonthlyTradingReport(user, filter));
	if (ordersReport) {
		fileDownload(new Blob([ordersReport as any], { type: "application/pdf" }), "SecMonthlyTrading.pdf");
	}
	dispatch(setFetchState({ type: "not-started" }));
};
